<!-- <dashboardnav> -->
    <cradua-seismic-currency [currencys]="currencys$ | async" (currency)="onSubmitCurrency($event)" (deleteCurrencyEvent)="onDeleteCurrency($event)"
      *ngIf="(isLoadingCurrency$ | async ) === false">
    </cradua-seismic-currency>
  
    <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingCurrency$ | async) === true">
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
  